import { Box } from 'grid-styled'

const AvatarImage = Box.withComponent('img').extend`
  border-radius: 50%;
  display: block;
  max-width: 140px;
`

export default AvatarImage



// WEBPACK FOOTER //
// /opt/build/repo/src/components/AvatarImage.js